import React, { Component } from 'react'
import { observer } from 'mobx-react'

import FormController from '../../form/FormController'
import Panel from '../../../UniformComponents/Panel'

@observer
export default class SurveyDetails extends Component {
    constructor(props) {
        super(props)
        this.fields = {}
    }

    async componentDidMount() {
        const { wizardStore } = this.props
        await wizardStore.initSurveyDetails()
        wizardStore.handleValidate = this.validate
    }

    validate = () => {
        const { wizardStore } = this.props
        const { formData } = wizardStore.surveyDetails
        return wizardStore.validate(this.fields, formData)
    }

    renderLoader = () => (
        <div className="loader" />
    )

    render() {
        const { wizardStore } = this.props
        return (
            <Panel cssClass="stage-card overflow-visible">
                <div id="survey-details">
                    {
                        wizardStore.surveyDetails.formLoading ? this.renderLoader()
                            : (
                                <FormController
                                    fields={this.fields}
                                    formFields={wizardStore.surveyDetails.formFields}
                                    setField={wizardStore.setSurveyDetailsField}
                                />
                            )
                    }
                </div>
            </Panel>
        )
    }
}
